import React, { Component } from "react";
import { Typography } from "antd";
import { contactSupport } from "../../../utils/links";
import { index } from "../../../utils/constants";

const { Text } = Typography;
class SummaryPanelErrorBoundary extends Component {
    state = {
        error: null,
        info: null,
    };
    componentDidCatch(error, info) {
        this.setState({ error, info });
    }
    render() {
        const { errors, cart, retry, children } = this.props;
        const { error, info } = this.state;
        if (error) {
            //if any error happens down the react component tree
            console.log({ error, info });
            return (
                <div>
                    <Text strong style={{ fontSize: "1rem" }}>
                        An error occurred displaying your summary. Please contact our support team:{" "}
                        {contactSupport}.
                    </Text>
                </div>
            );
        } else if (!cart || !cart.items) {
            //no plan is selected
            return (
                <div>
                    <Text strong style={{ fontSize: "1rem" }}>
                        You haven't select any plan yet. Please start by selecting a plan from the{" "}
                        <a href={index}>pricing page</a> page.
                    </Text>
                </div>
            );
        } else if (errors.preview) {
            //no preview is retrieved
            return (
                <div>
                    <Text strong style={{ fontSize: "1rem" }}>
                        We couldn't retrieve your plan summary at the moment, please{" "}
                        <a href="#/" onClick={() => retry()}>
                            try again
                        </a>{" "}
                        later or contact our support team: {contactSupport}.
                    </Text>
                </div>
            );
        } else {
            return children;
        }
    }
}

export default SummaryPanelErrorBoundary;
